import { action, get } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Planbook, PlanbookCollaborator } from "@shared/models/planbook"
import { handleError } from "cc-frontend/error-handling"
import findDocument from "cc-frontend/helpers/find-document"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"

interface Args {
  planbook: Planbook
  collaborator: PlanbookCollaborator
  canChangeCollaborators: boolean
}

export default class PlanbookCollaboratorComponent extends Component<Args> {
  @service("ember-store") store!: EmberStore
  @service rpc!: Rpc
  @service dialog

  @findDocument("args.collaborator.attributes.groupId", "group") group

  @findDocument("args.collaborator.attributes.userId", "user") user

  @action
  removeCollaborator(collaboratorId, event) {
    event.preventDefault()
    get(this, "dialog")
      .blank("dialogs/confirm-delete-planbook-collaborator", {
        className: "dialog--create-annotation",
      })
      .then(() => {
        this.rpc.planbook_collaboration_remove_collaborator({
          planbookId: this.args.planbook.id,
          collaboratorId: collaboratorId,
        })
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }
}
